export const MroExcelHeader = [
  {
    header: "MRO CODE",
    key: "MRO CODE",
    width: 25,
  },
  {
    header: "MRO NAME",
    key: "MRO CODE",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
];

export const MroExcelName = "MRO List";
